import styled from "styled-components";
const breakpointLG = "1024px";
const paddingLG = "40px";
const paddingSM = "20px";
export const MastheadContentBox = styled.div `
  grid-area: 2 / 1 / 2 / 2;
  font-family: Inter, sans-serif;
  display: flex;
  width: 100%;
  max-width: 550px;
  flex-direction: column;
  padding-top: 125px;
  padding-left: ${paddingLG};
  color: #ece8e1;

  @media (max-width: ${breakpointLG}) {
    /* position: absolute;
    left: 0;
    top: 0; */
    padding-top: 30px;
    padding-left: ${paddingSM};
    padding-right: ${paddingSM};
  }

  .info {
    font-size: 12px;
    font-weight: 400;
    line-height: 1.5;
    margin-bottom: 20px;
  }

  .description {
    font-size: 15px;
    font-weight: 400;
    line-height: 1.5;
    margin-bottom: 50px;
  }

  .rating {
    border: 1px solid #ece8e1;
    width: 80px;
    height: 73px;
    text-align: center;
    display: flex;
    justify-content: center;
    flex-direction: column;
    align-items: center;
    color: #9a9a9a;

    > *:last-child {
      font-size: 20px;
      padding-top: 10px;
      color: #ece8e1;
    }
  }
`;
//# sourceMappingURL=styles.js.map